import { Button } from "@/components/ui/button";
import { router } from "@inertiajs/react";
import { useState } from "react";

interface FollowButtonProps {
  userId: number;
  isFollowing: boolean;
  className?: string;
}

export default function FollowButton({
  userId,
  isFollowing,
  className = "",
}: FollowButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleFollow = () => {
    setIsLoading(true);
    router.post(
      `/users/${userId}/follow`,
      {},
      {
        onFinish: () => setIsLoading(false),
      }
    );
  };

  const handleUnfollow = () => {
    setIsLoading(true);
    router.delete(`/users/${userId}/unfollow`, {
      onFinish: () => setIsLoading(false),
    });
  };

  if (isFollowing) {
    return (
      <Button
        onClick={handleUnfollow}
        disabled={isLoading}
        variant="outline"
        className={`text-red-600 border-red-600 hover:bg-red-50 ${className}`}
      >
        {isLoading ? "Unfollowing..." : "Unfollow"}
      </Button>
    );
  }

  return (
    <Button onClick={handleFollow} disabled={isLoading} className={className}>
      {isLoading ? "Following..." : "Follow"}
    </Button>
  );
}
